export default __webpack_public_path__ + "static/nuevacode-logo-combined-f37e968f4854b359bbdb818f0edf4a44.svg";